<template>
  <el-dialog title="编辑价格" :visible.sync="_dialogVisible" :before-close="handleClose">
    <el-form :model="listParams" ref="formEdit">
      <template v-if="type == 1">
        <el-form-item prop="price" label="商品价格" :rules="[{ required: true, message: '请填写该商品价格', trigger: `blur` }]">
          <el-input size="small" @change="handleSetPrice" v-model="listParams.price" style="width: 220px" />
        </el-form-item>

        <el-form-item
          v-for="(item, index) in listParams.goodLevelPrices"
          :prop="`goodLevelPrices[${index}].levelPrice`"
          :key="item.id"
          :label="`${item.levelName}-商品价格`"
          label-width="350upx"
          :rules="[{ required: true, message: '请填写该商品价格', trigger: `blur` }]"
        >
          <el-input
            size="small"
            style="width: 220px"
            :disabled="!listParams.price"
            v-model="item.levelPrice"
            :placeholder="`请输入${item.levelName}的商品价格`"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button type="primary" @click="handleSubmit">修改</el-button>
        </el-form-item>
      </template>

      <template v-else-if="type == 2">
        <el-form-item prop="price" label="参考价格" :rules="[{ required: true, message: '请填写参考价格', trigger: `blur` }]">
          <el-input size="small" v-model="listParams.price" style="width: 220px" />
        </el-form-item>

        <el-form-item label="">
          <el-button type="primary" @click="handleSubmitSub">修改</el-button>
        </el-form-item>
      </template>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    doalogData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      type: 1,
      listParams: {
        id: "",
        price: "",
        goodLevelPrices: []
      }
    };
  },
  computed: {
    _dialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", false);
      }
    }
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val && this.doalogData.id) {
          this.listParams = { ...this.doalogData };
          this.type = this.doalogData.type || 1;
        }
      }
    }
  },
  methods: {
    handleResetPrice() {
      this.listParams = { id: "", price: "", goodLevelPrices: [] };
      this.type = 1;
    },
    /**
     * 设置价格
     */
    handleSetPrice() {
      this.listParams.goodLevelPrices.forEach((item) => {
        item.levelPrice = this.listParams.price;
      });
    },
    /**
     * 关闭弹窗
     * @params *
     */
    handleClose() {
      this._dialogVisible = false;
    },

    /**
     * 提交
     */
    handleSubmit() {
      this.$refs.formEdit.validate((valid) => {
        if (valid) {
          this.$http({
            url: global.apiUrl + "/good/gooddetail/adjustPrice",
            method: "PUT",
            body: {
              id: this.listParams.id,
              price: parseFloat(this.listParams.price),
              goodLevelPrices: this.listParams.goodLevelPrices
            }
          })
            .then((res) => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.$emit("refresh");
                this.handleResetPrice();
                this.handleClose();
              } else {

              }
            })
            .catch(() => {

            });
        }
      });
    },
    /**
     * 修改菜品单价
     */
    handleSubmitSub() {
      const price = this.listParams.price;
      if (price === "") {
        this.$message.error("商品单价不能为空");
        return;
      }
      if (isNaN(parseFloat(price))) {
        this.$message.error("请输入数字");
        return;
      }
      this.$http({
        url: global.apiUrl + "/good/gooddetail/adjustReferPrice",
        method: "PUT",
        body: {
          id: this.listParams.id,
          price: parseFloat(price)
        }
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.$emit("refresh");
            this.handleResetPrice();
            this.handleClose();
          } else {

          }
        })
        .catch(() => {

        });
    }
  }
};
</script>
